import React from 'react';
import { connect } from 'react-redux';
import { Map } from 'immutable';

import dietaryFilters from 'components/Alert/alerts/AllergenFilter/dietaryFilters';
import { allergenContactStaff } from 'selectors/features';
import { selectIsIndianVenue } from 'selectors/root';

import { Container, StyledAllergenIcon } from './styles';

type Props = {
  product: Map<string, any>;
  allergenContactStaff?: boolean;
  isIndianVenue?: boolean;
};

const SuitableFor = ({ product, allergenContactStaff, isIndianVenue }: Props) => {
  if (allergenContactStaff) {
    return null;
  }

  return (
    <Container>
      {dietaryFilters
        .get('lifestyleChoices')
        .concat(dietaryFilters.get('allergensAsLifestyleChoices'))
        .map((lifestyleChoice, index) => {
          const allergens = product?.get('allergens');
          const canCheckIncludes =
            allergens && (Array.isArray(allergens) || typeof allergens.includes === 'function');
          return (
            (product?.get(lifestyleChoice) || (canCheckIncludes && allergens.includes(lifestyleChoice))) && (
              <StyledAllergenIcon
                allergenName={lifestyleChoice}
                isIndianVenue={isIndianVenue}
                width="20px"
                height="20px"
                key={index}
              />
            )
          );
        })}
    </Container>
  );
};

const mapStateToProps = state => ({
  allergenContactStaff: allergenContactStaff(state),
  isIndianVenue: selectIsIndianVenue(state),
});

export default connect(mapStateToProps)(SuitableFor);
